import { Grid, Paper, Typography } from '@material-ui/core';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ListSubheader from '@material-ui/core/ListSubheader';
import { makeStyles } from '@material-ui/core/styles';
import { CloudDownload, Favorite, Help, Mic, People, QuestionAnswer, Subscriptions, ViewCarousel } from '@material-ui/icons';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import React from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import image1 from '../../assets/sponsors/image1.png';
import image10 from '../../assets/sponsors/image10.png';
import image11 from '../../assets/sponsors/image11.png';
import image2 from '../../assets/sponsors/image2.png';
import image3 from '../../assets/sponsors/image3.png';
import image4 from '../../assets/sponsors/image4.png';
import image5 from '../../assets/sponsors/image5.png';
import image6 from '../../assets/sponsors/image6.png';
import image7 from '../../assets/sponsors/image7.png';
import image8 from '../../assets/sponsors/image8.png';
import image9 from '../../assets/sponsors/image9.png';
import Logo from '../Logo';
import Bannerette from '../Logo/bannerette';

import listaOral from '../../assets/Ap_oral_selecionados_IIIMostra.xlsx';
import logoEvento from '../../assets/bannerette-azul.jpg';
import listaBanner from '../../assets/Banners_selecionados_IIIMostra.xlsx';
import modeloBanner from '../../assets/IIIMostra_Banners.pptx';
import orientacoesBanner from '../../assets/Normas_banners_IIIMostra.pdf';
import orientacoesOral from '../../assets/Normas_oral_IIIMostra.pdf';

import { datas, linkBanner, linkResumo } from '../../Constants';
import GridTitle from '../GridTitle';

const useStyles = makeStyles((theme) => ({
    logo: {
        marginBottom: 24,
        display: "flex",
        justifyContent: "center",
    },
    root: {
        width: '100%',
        backgroundColor: theme.palette.background.paper,
    },
    nested: {
        paddingLeft: theme.spacing(4),
    },
    paper: {
        padding: theme.spacing(3),
        textAlign: 'left',
        color: theme.palette.text.secondary,
        margin: '10px'
    },
    itemContainer: {
        display: 'flex',
        justifyContent: 'flex-start',
        [theme.breakpoints.down('sm')]: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center'
        }
    },
}));

const comissao = {
    "Coordenação": [
        {
            "nome": "Profa Gloria R. Botelho"
        }
    ],
    "Comissão Organizadora": [
        {
            "nome": "Prof. Alexandre Tavela"
        },
        {
            "nome": "Profa Gloria R. Botelho"
        },
        {
            "nome": "Prof. Kelen Haygert Lencina"
        },
        {
            "nome": "Prof. Luciano Picolotto"
        },
        {
            "nome": "Prof. Vitor Braga Rissi"
        },
        {
            "nome": "Ketlin Schneider"
        },
        {
            "nome": "Ana Paula Dondoerfer Teixeira"
        },
        {
            "nome": "Andressa Bianeck"
        },
        {
            "nome": "Cintia Faquin"
        },
        {
            "nome": "Daiane Tâmisa Bezutti Saleh"
        },
        {
            "nome": "Giulia Canale Medeiros"
        },
        {
            "nome": "Maria Laura Enzele"
        },
        {
            "nome": "Miriam Izabel Dobler"
        },
        {
            "nome": "Sabrina Freitas Da Cruz"
        }
    ],
    "Comissão Científica de Agronomia": [
        {
            "nome": "Prof. Douglas Adams Weiler"
        },
        {
            "nome": "Profa Glória Botelho"
        },
        {
            "nome": "Prof. João Paulo Rigon"
        },
        {
            "nome": "Profa Júlia Carina Niemeyer"
        },
        {
            "nome": "Prof. Luciano Picolotto"
        },
        {
            "nome": "Profa Rita Carolina de Melo"
        },
        {
            "nome": "Prof. Willian R. Macedo"
        },
        {
            "nome": "Caio Bustani Andrade"
        },
        {
            "nome": "Cintia Faquin"
        },
        {
            "nome": "Daniel A. Heberle"
        },
        {
            "nome": "Gustavo Eduardo Pereira"
        },
        {
            "nome": "Ketlin Schneider"
        }
    ],
    "Comissão Científica de Engenharia Florestal": [
        {
            "nome": "Profa Amanda Koche Marcon"
        },
        {
            "nome": "Profa Karina Soares Modes"
        },
        {
            "nome": "Profa Kelen H. Lencina"
        },
        {
            "nome": "Prof. Magnos Alan Vivian"
        },
        {
            "nome": "Prof. Marcelo Bonazza"
        },
        {
            "nome": "Prof. Vinicius C. Cysneiros"
        },
        {
            "nome": "Daiane Tâmisa Bezutti Saleh"
        },
        {
            "nome": "Miriam Izabel Dobler"
        }
    ],
    "Comissão Científica de Med. veterinária": [
        {
            "nome": "Prof. Alexandre Tavela"
        },
        {
            "nome": "Profa. Amanda Bastos"
        },
        {
            "nome": "Prof. Fernando Rocha Miranda"
        },
        {
            "nome": "Prof. Giuliano Moraes Figueiro"
        },
        {
            "nome": "Prof. Marcos Barreta"
        },
        {
            "nome": "Prof. Rogério Manoel Lemes de Campos"
        },
        {
            "nome": "Prof. Vitor Braga Rissi"
        },
        {
            "nome": "Ana Paula Dondoerfer Teixeira"
        },
        {
            "nome": "Andressa Bianeck"
        },
        {
            "nome": "Cleiton Pereira"
        },
        {
            "nome": "Giulia Canale Medeiros"
        },
        {
            "nome": "Larissa Jonk"
        },
        {
            "nome": "Maria Laura Enzele"
        },
        {
            "nome": "Sabrina Freitas Da Cruz"
        }
    ]
}

const palestrantes = [
    {
        "nome": "Adriana Francisco",
        "biografia": "Possui graduação em Agronomia pela Universidade Estadual de Ponta Grossa. Atualmente, é Extensionista Rural - Nível superior da Empresa de Pesquisa Agropecuária e Extensão Rural de Santa Catarina (EPAGRI), na cidade de Frei Rogério (SC)."
    },
    {
        "nome": "Amanda Köche Marcon",
        "biografia": "Professora na UFSC, é Engenheira Florestal (UDESC) e Doutora em Engenharia Florestal (UFPR). Desenvolve pesquisas em Conservação da Natureza, Impacto Ambiental e Mudanças Climáticas."
    },
    {
        "nome": "Andreas Lazaros Chryssafidis",
        "biografia": "Médico Veterinário pela Universidade Estadual de Londrina (UEL, 2006). Doutor em Epidemiologia Experimental Aplicada às Zoonoses (Doutorado Direto) pela Universidade de São Paulo (VPS-FMVZ-USP, 2012). Pesquisador Pós-Doutor na University College Dublin (UCD, 2012-2015) trabalhando com desenvolvimento e teste de vacinas antiparasitárias. Mestre em Medicina Veterinária (mestrado integrado, grau profissional europeu) pela Universidade de Lisboa (ULisboa, 2016). Médico Veterinário Parasitologista no Laboratório de Diagnóstico Parasitológico do Hospital Veterinário da University College Dublin (UVH, 2012-2015). Médico Veterinário Parasitologista da empresa Charles River Laboratories - Ireland (2015-2016), estabelecendo o único laboratório de parasitologia da Irlanda certificado para estudos GCP e GLP. Professor Adjunto no curso de Medicina Veterinária da Universidade Estadual de Londrina - UEL, ministrando as disciplinas de Parasitologia Veterinária, Doenças Parasitárias de Animais Domésticos, Parasitologia Aplicada à Zootecnia e Toxicologia Veterinária (2015 - 2018). Coordenador do Laboratório de Toxicologia Veterinária, ToxiVet-UEL (2015 - 2018). Professor Adjunto da Universidade do Estado de Santa Catarina - CAV-UDESC, ministrando as disciplinas de Parasitologia Veterinária e Doenças Parasitárias (2019 - atual). Coordenador do Laboratório de Desenvolvimento de Tecnologias em Saúde, LATEDES-CAV-UDESC. Professor Permanente no Programa de Pós-Graduação em Ciência Animal (PPGCA-CAV-UDESC), orientador de Mestrado e Doutorado. Ministra as disciplinas de Zoonoses Parasitárias, Parasitoses em Ruminantes, Parasitoses em Pequenos Animais e disciplinas ligadas ao empreendedorismo. Atual representante do Núcleo de Inovação Tecnológica no CAV-UDESC. O pesquisador vem atuando em pesquisas com doenças parasitárias animais e zoonóticas, desde 2002, com foco no desenvolvimento e teste de novas tecnologias para o diagnóstico e controle destas enfermidades."
    },
    {
        "nome": "Bruno Polli Domanowski",
        "biografia": "É graduado em Eng. Florestal pela Universidade Federal do Paraná. MBA em finanças e controladoria pela Universidade OPET. MBA em Gestão empresarial pela universidade FGV. Trajetória profissional: Líder de restauração ambiental em Seattle-WA (2 anos – ONG EathCorps), Especialista de Planejamento Florestal em Três Lagoas-MS (3 anos - Eldorado Brasil), Gerente de consultoria em Curitiba-PR (8 anos - Pöyry), Gerente de avaliações de ativos biológicos em Curitiba (1 ano – KPMG), Diretor de consultoria em Campinas-SP (1 ano - ESG Tech) Atualmente Gerente de Inteligência de Mercado em São Paulo-SP (1.5 anos – Suzano)."
    },
    {
        "nome": "Gerson Santino Cecconello",
        "biografia": "Engenheiro Agrônomo formado pela Universidade Federal de Pelotas (UFPEL -Faculdade de Agronomia Eliseu Maciel). Iniciou a jornada profissional na ACARESC (atual EPAGRI ), onde exerceu função de extensionista e assistente técnico. Por 30 anos, trabalhou como responsável técnico na COOPERPLAC / COOPERALHO. Atualmente, é engenheiro agrônomo na Copercampos, filial Curitibanos, responsável pelo desenvolvimento do projeto hortifruticultura (HF). Sua especialidade sempre foi HF, especialmente, com as culturas do alho, cebola, melancia, moranga e afins."
    },
    {
        "nome": "Hamilton Justino Vieira",
        "biografia": "Graduação em Engenharia Agronômica pela Universidade Federal de Pelotas (1981), mestrado em Agronomia pela Universidade de São Paulo, USP (1984) e doutorado em Fitotecnia na Alemanha - Hohenheim Universitaet (1997). Pós Doutorado no CIRAD-Montpellier na França (2010). Foi bolsista de iniciação científica o CNPq na graduação, bolsista da CAPES no Mestrado, bolsita no Doutorado do CNPq e DAAD e bolsista da CAPES no Pós Doutorado. Foi presidente da Sociedade Brasileira de Agrometeorologia (1998/99). Atualmente é pesquisador da Empresa de Pesquisa Agropecuária e Extensão Rural de Santa Catarina S.A.-EPAGRI. Exerceu a gerência do CIRAM - Centro de Informações de Recursos Ambientais e de Hidrometeorologia. Foi lider do grupo de pesquisa de AGROMETEOROLOGIA-SC junto ao CNPq. Tem experiência na área de Agrometeorologia, com ênfase em monitoramento ambiental (apicultura, fruticultura, olericultura), Ecofisiologia de plantas, atuando principalmente nos seguintes temas: cultura da videira, cebola. Desenvolve pesquisas e estudos climáticos para indicações geográficas, micrometeorologia, operação e manutenção de redes de estações hidrometeorológicas, extruturação de informações para o desenvolvimento em Base Web de sistemas de difusão de informações agrometeorológicas (Agroalertas)."
    },
    {
        "nome": "Jacques Mick",
        "biografia": "Com graduação em Comunicação Social - Jornalismo pela UFSC (1992), tem mestrado e doutorado em Sociologia Política pela UFSC (1998, 2004) e pós-doutorado na Universidade de Lisboa (2014-2015). Foi professor visitante no Instituto de Estudos Políticos (Sciences Po) de Grenoble em 2014 e 2017. Coordena as pesquisas Transformações no perfil profissional de jornalistas no Brasil (2012-2021), Journalistic role performance - Etapa Brasil (2020-2024) e flexMediaLives - Aferição e análise de riscos biográficos em mercados de trabalho flexíveis. É professor dos Programas de Pós-Graduação em Jornalismo e em Sociologia e Ciência Política Universidade Federal de Santa Catarina, vinculado ao Departamento de Sociologia e Ciência Política. Atua nos grupos de pesquisa Laboratório de Sociologia do Trabalho e Metrópolis - Laboratório de Pesquisa Social. Foi subcoordenador e coordenador do Programa de Pós-Graduação em Sociologia Política (PPGSP), entre 2015 e 2016, subchefe (2017-2019) e chefe (2019-2020) de Departamento de Sociologia e Ciência Política e vice-diretor do Centro de Filosofia e Ciências Humanas da UFSC (2020-2022). Atualmente, é pró-reitor de Pesquisa e Inovação da UFSC (2022-)."
    },
    {
        "nome": "Julia Carina Niemeyer",
        "biografia": "Doutora em Ecologia pela Universidade de Coimbra, Portugal. Docente na UFSC Campus de Curitibanos, atualmente subcoordenadora do PPG Ecossistemas Agrícolas e Naturais e Coordenadora de TCC do Curso de Engenharia Florestal.  Revisora de vários periódicos internacionais e Editora Associada da revista Ecotoxicology (Springer). Pesquisadora produtividade em pesquisa do CNPQ, nível 2."
    },
    {
        "nome": "Maykol Ouriques",
        "biografia": "Possui graduação em Agronomia pela Universidade Federal de Santa Catarina, pós graduação em Gestão Ambiental de Sistemas Agrícolas pela Universidade Federal de Lavras - MG. Atuou como pesquisador convidado na Universidade da Califórnia em Berkeley na área de agroecologia. Atuação como engenheiro agrônomo - BRF - Brasil Foods como coordenador de gestão ambiental e crédito agrícola, desenvolvendo sistema em Visual Basic For Application para gestão e controle de resíduos e licenciamento ambiental para BRF em SC. Atuação como extensionista rural na Epagri, como Gerente Regional de Extensão Rural, como Gerente da Estação Experimental da Epagri de Campos Novos e atualmente atuo na EPAGRI como Coordenador de ATER na UGT 2 e no Núcleo de Inovação Tecnológica da Epagri (NIT). Experiência na área de Agronomia, com ênfase em Gestão Ambiental, Gestão de Empreendimentos, atuando principalmente nos seguintes temas: Gestão de Empreendimentos Agrícolas, Educação Ambiental, Produção de leite e carne a pasto, Manejo de Resíduos Agrícolas, Agroecologia, Elaboração de Projetos, gerenciamento de Pessoas. Desenvolvedor Web e de aplicativos, atuando no Planejamento e Desenvolvimento de Sistemas de Gestão com Visual Basic For Applications (VBA) e framework Bubble."
    },
    {
        "nome": "Marco Antônio Lucini",
        "biografia": "É graduado em Engenharia Agronômica pela Universidade Federal de Pelotas. Foi Agente Técnico de Formação Superior III da Empresa de Pesquisa Agropecuária e Extensão Rural de Santa Catarina (EPAGRI). Ampla experiência na Fitotecnia, com ênfase em, no cultivo do alho, sobre o qual produziu diversas publicações."
    },
]

const normalListItem = [
    { title: "O que é a III Mostra Científica da UFSC - Curitibanos?", icon: <QuestionAnswer />, link: 'o-que-e-a-iii-mostra-cientifica-da-ufsc-curitibanos' },
    { title: "Como fazer minha inscrição no evento?", icon: <Subscriptions />, link: 'como-fazer-minha-inscricao-no-evento' },
    //{ title: "Como posso enviar meu resumo?", icon: <SendIcon />, link: 'como-posso-enviar-meu-resumo' },
    // { title: "Modelo de Resumo", icon: <CloudDownload />, link: 'modelo-de-resumo' },
    // { title: "Modelo de Banners", icon: <FileCopyOutlined />, link: 'modelo-de-apresentacao-banner' },
    // { title: "Modelo de Apresentação Oral", icon: <FileCopyOutlined />, link: 'modelo-de-apresentacao-oral' },
    { title: "Datas Importantes", icon: <AccessTimeIcon />, link: 'datas-importantes' },
    { title: "Biografia dos Palestrantes", icon: <People />, link: 'biografia-dos-palestrantes' },
    { title: "Sobre Apresentações em Banner", icon: <ViewCarousel />, link: 'sobre-apresentacoes-em-banner' },
    { title: "Sobre Apresentações Orais", icon: <Mic />, link: 'sobre-apresentacoes-orais' },
    { title: "Nossos Apoiadores", icon: <Favorite />, link: 'apoiadores' },
    { title: "O que é o ConTech?", icon: <Help />, link: 'o-que-e-o-contech' },
];

export default function CardCollapse() {
    const classes = useStyles();
    const location = useLocation();
    const history = useHistory();
    const searchParams = new URLSearchParams(location.search);
    const tab = searchParams.get('tab');
    const [selectedList, setSelectedList] = React.useState(tab || 'o-que-e-a-iii-mostra-cientifica-da-ufsc-curitibanos');

    const handleNormalListItem = (link) => {
        setSelectedList(link);
        history.push(`?tab=${link}`);
    }

    const contentList = [
        {
            param: 'o-que-e-a-iii-mostra-cientifica-da-ufsc-curitibanos',
            body: (
                <Grid container direction="column">
                    <GridTitle title="O que é a III Mostra Científica da UFSC - Curitibanos?" />
                    <br />
                    <Grid item>
                        <div className={classes.logo}>
                            <Bannerette />
                        </div>
                    </Grid>
                    <Grid item>
                        <Typography variant="body1">
                            O evento se propõe a divulgar a produção científica e tecnológica do campus de Curitibanos da UFSC, Centro Ciências Rurais (CCR) entre a comunidade acadêmica e a região. Pretende-se ampliar a integração acadêmica para incentivar colaborações e cooperações. Pretende também, divulgar a produção para e de outras instituições de ensino e pesquisa, estabelecendo novas parcerias. Além disso, um outro objetivo é ampliar e fortalecer a cooperação com o setor produtivo, através de empresas que participam do evento com seus produtos e profissionais. Por isso, o tema do evento é <i>Tecnologias e inovações agrárias</i>.
                        </Typography>
                    </Grid>
                </Grid>
            )
        },
        {
            param: 'como-fazer-minha-inscricao-no-evento',
            body: (
                <Grid container direction="column">
                    <GridTitle title={"Como fazer minha inscrição no evento?"} />
                    <br />
                    <br />
                    <Grid item>
                        <Typography style={{ color: 'red' }}>
                            As inscrições como participante e, consequentemente como apresentador, são PAGAS.
                        </Typography>
                        <br />
                        <Typography>
                            As categorias são:
                            <ul>
                                <li>Estudantes de graduação - R$20,00</li>
                                <li>Estudantes de pós-graduação - R$30,00</li>
                                <li>Profissionais - R$50,00</li>
                                <li>Acompanhantes - R$15,00 (sem certificado)</li>
                            </ul>
                        </Typography>
                        <Typography style={{ color: 'red' }}>
                            Primeiro, o pagamento é feito via PIX para a chave 51.401.978/0001-04 (Empresa - MAFRA E RIBEIRO SERVIÇOS LTDA).
                        </Typography>
                        <br />
                        <Typography style={{ color: 'red' }}>
                            Em seguida, envie o comprovante para o e-mail da Mostra: <a href="mailto:mostra.curitibanos@contato.ufsc.br">mostra.curitibanos@contato.ufsc.br</a> para que o link da inscrição seja enviado ao seu email.
                        </Typography>
                        <br />
                    </Grid>
                </Grid>
            )
        },
        {
            param: 'como-posso-enviar-meu-resumo',
            body: (
                <Grid container direction="column">
                    <GridTitle title="Como posso enviar meu resumo?" />
                    <br />
                    <Grid item>
                        <Typography>
                            Você pode enviar seu resumo para a III Mostra Científica e Tecnológica da UFSC - <i>campus</i> Curitibanos.
                            <br /><br />
                            Quer saber como? Faça o seguinte:
                            <ol>
                                <li>Baixe o modelo na aba de <Link to="/mais?tab=modelo-de-resumo">"Modelo de Resumo"</Link></li>
                                <li>Adapte seu resumo</li>
                                <li><Link to="/inscreva-se">Preencha o formulário de inscrição no ConTech </Link></li>
                                <li>Leia o Termo de Permissão e Sigilo e caso concorde, e caso concorde, aceite-o</li>
                                {/* <li style={{ color: 'red' }}>Para certificado, acesse link <a href={UT[0].link} target="_blank" rel="noopener noreferrer">Link</a></li> */}
                                <li style={{ color: 'red' }}>Pronto! Sua inscrição está reservada! Agora falta só efetuar o pagamento, conforme a aba <Link to="/mais?tab=como-fazer-minha-inscricao-no-evento">"Como fazer minha inscrição no evento?"</Link></li>
                            </ol>
                        </Typography>
                        <div>
                            {/* <iframe src="https://modeler.cloud.camunda.io/embed/d054a917-b0a2-4ba3-80a1-c541af316de3" width="700" height="500" style={{ borderWidth: '1px', borderColor: "#ccc" }} allowFullScreen></iframe> */}
                        </div>
                    </Grid>
                </Grid>
            )
        },
        {
            param: 'datas-importantes',
            body: (
                <Grid container direction="column">
                    <GridTitle title="Datas Importantes" />
                    <br />
                    <Grid item>
                        <Typography>
                            <List>
                                {
                                    datas.map((el, i) => (
                                        <ListItem key={i}>
                                            <ListItemText primary={<b>{el.title}</b>} secondary={el.date} />
                                        </ListItem>
                                    ))
                                }
                            </List>
                        </Typography>
                    </Grid>
                </Grid>
            )
        },
        {
            param: 'biografia-dos-palestrantes',
            body: (
                <Grid container direction="column">
                    <GridTitle title={"Biografia dos Palestrantes"} />
                    <br />
                    {
                        palestrantes.map((el, i) => (
                            <ListItem key={i}>
                                <Typography>
                                    <b>
                                        {el.nome}
                                    </b>
                                    <br />
                                    <ListItemText primary={el.biografia} />
                                </Typography>
                            </ListItem>
                        ))
                    }
                </Grid>
            )
        },
        {
            param: 'comite-cientifico',
            body: (
                <Grid container direction="column">
                    <GridTitle title="Comissões" />
                    <br />
                    <table>
                        <tbody>
                            {
                                Object.keys(comissao).map((el, i) => (
                                    <React.Fragment key={i}>
                                        <tr>
                                            <Typography>
                                                <td colSpan="2"><b>{el}</b></td>
                                            </Typography>
                                        </tr>
                                        {
                                            comissao[el].map((el2, i2) => (
                                                <tr key={i2}>
                                                    <Typography>
                                                        <td>{el2.nome}</td>
                                                    </Typography>
                                                </tr>
                                            ))
                                        }
                                    </React.Fragment>
                                ))
                            }
                        </tbody>
                    </table>
                </Grid>
            )
        },
        {
            param: 'modelo-de-resumo',
            body: (
                <Grid container direction="column">
                    <GridTitle title="Modelo de Resumo" />
                    <br />
                    <Grid item>
                        <Typography>
                            <List>
                                <ListItem>
                                    <Typography>
                                        <a
                                            href={linkResumo}
                                            target="_blank" rel="noopener noreferrer"
                                            download
                                        >
                                            <CloudDownload style={{ marginRight: '5px' }} />
                                            <ListItemText primary="Modelo de Resumo em .docx" />
                                        </a>
                                    </Typography>
                                </ListItem>
                            </List>
                        </Typography>
                    </Grid>
                </Grid>
            )
        },
        {
            param: 'modelo-de-apresentacao',
            body: (
                <Grid container direction="column">
                    <GridTitle title="Modelo de Apresentação" />
                    <br />
                    <Grid item>
                        <Typography>
                            <List>
                                <ListItem>
                                    <Typography>
                                        <a
                                            href={linkBanner}
                                            target="_blank" rel="noopener noreferrer"
                                            download
                                        >
                                            <CloudDownload style={{ marginRight: '5px' }} />
                                            <ListItemText primary="Modelo de Banner em .pptx" />
                                        </a>
                                    </Typography>
                                </ListItem>
                            </List>
                        </Typography>
                    </Grid>
                </Grid>
            )
        },
        {
            param: 'sobre-apresentacoes-em-banner',
            body: (
                <Grid container direction="column">
                    <GridTitle title="Sobre Apresentações em Banner" />
                    <br />
                    <Grid item>
                        <Typography>
                            Caso seu trabalho:
                            <ul>
                                <li>seja aceito</li>
                                <li>seja da UFSC</li>
                                <li>seja selecionado(a)</li>
                            </ul>
                            <br />
                            A numeração do banner está na lista anexada.
                            <br />
                            Siga as orientações do documento em pdf em anexo e utilize o modelo de banner (pptx) também em anexo.
                            <br />
                            <br />
                            <b>Modelo de banner não deve ser alterado.</b>
                            <Grid container direction="column">
                                <Grid item>
                                    <Typography>
                                        <List>
                                            <ListItem>
                                                <Typography>
                                                    <a
                                                        href={listaBanner}
                                                        target="_blank" rel="noopener noreferrer"
                                                        download
                                                    >
                                                        <CloudDownload style={{ marginRight: '5px' }} />
                                                        <ListItemText primary="Lista de selecionados para banner em .xlsx" />
                                                    </a>
                                                </Typography>
                                            </ListItem>
                                        </List>
                                    </Typography>
                                </Grid>
                                <Grid item>
                                    <Typography>
                                        <List>
                                            <ListItem>
                                                <Typography>
                                                    <a
                                                        href={orientacoesBanner}
                                                        target="_blank" rel="noopener noreferrer"
                                                        download
                                                    >
                                                        <CloudDownload style={{ marginRight: '5px' }} />
                                                        <ListItemText primary="Orientações em .pdf" />
                                                    </a>
                                                </Typography>
                                            </ListItem>
                                        </List>
                                    </Typography>
                                </Grid>
                                <Grid item>
                                    <Typography>
                                        <List>
                                            <ListItem>
                                                <Typography>
                                                    <a
                                                        href={modeloBanner}
                                                        target="_blank" rel="noopener noreferrer"
                                                        download
                                                    >
                                                        <CloudDownload style={{ marginRight: '5px' }} />
                                                        <ListItemText primary="Modelo de Banner em .pptx" />
                                                    </a>
                                                </Typography>
                                            </ListItem>
                                        </List>
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Typography>
                    </Grid>
                </Grid>
            )
        },
        {
            param: 'sobre-apresentacoes-orais',
            body: (
                <Grid container direction="column">
                    <GridTitle title="Sobre Apresentações Orais" />
                    <br />
                    <Grid item>
                        <Typography>
                            Caso seu trabalho:
                            <ul>
                                <li>seja aceito</li>
                                <li>seja da UFSC</li>
                                <li>seja selecionado(a)</li>
                            </ul>
                            <br />
                            Você receberá um email com a data e o horário de sua apresentação.
                            <br /><br />
                            <b>Leia atentamente as orientações em pdf, em anexo.</b>
                            <br />
                            <b>A apresentação é de responsabilidade e criatividade de cada um.</b>
                            <br /><br />
                            <Grid container direction="column">
                                <Grid item>
                                    <Typography>
                                        <List>
                                            <ListItem>
                                                <Typography>
                                                    <a
                                                        href={listaOral}
                                                        target="_blank" rel="noopener noreferrer"
                                                        download
                                                    >
                                                        <CloudDownload style={{ marginRight: '5px' }} />
                                                        <ListItemText primary="Lista de selecionados para apresentação oral em .xlsx" />
                                                    </a>
                                                </Typography>
                                            </ListItem>
                                        </List>
                                    </Typography>
                                </Grid>
                                <Grid item>
                                    <Typography>
                                        <List>
                                            <ListItem>
                                                <Typography>
                                                    <a
                                                        href={orientacoesOral}
                                                        target="_blank" rel="noopener noreferrer"
                                                        download
                                                    >
                                                        <CloudDownload style={{ marginRight: '5px' }} />
                                                        <ListItemText primary="Orientações em .pdf" />
                                                    </a>
                                                </Typography>
                                            </ListItem>
                                        </List>
                                    </Typography>
                                </Grid>
                                <Grid item>
                                    <Typography>
                                        <List>
                                            <ListItem>
                                                <Typography>
                                                    <a
                                                        href={logoEvento}
                                                        target="_blank" rel="noopener noreferrer"
                                                        download
                                                    >
                                                        <CloudDownload style={{ marginRight: '5px' }} />
                                                        <ListItemText primary="Logo do evento" />
                                                    </a>
                                                </Typography>
                                            </ListItem>
                                        </List>
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Typography>
                    </Grid>
                </Grid>
            )
        },
        {
            param: 'o-que-e-o-contech',
            body: (
                <Grid container direction="column">
                    <GridTitle title="O que é o ConTech?" />
                    <br />
                    <Grid item>
                        <div className={classes.logo}>
                            <Logo />
                        </div>
                    </Grid>
                    <Grid item>
                        <Typography variant="body1">
                            <b>O ConTech é o sistema de submissão de trabalhos oficial da III Mostra Científica e Tecnológica da UFSC - <i>campus</i> Curitibanos.</b>
                            <br /><br />
                            Por aqui, você pode enviar seu resumo, acompanhar o status de sua inscrição e muito mais.
                            Além disto, pela plataforma, os avaliadores analisam os resumos e a equipe organizadora gerenciar o evento.
                        </Typography>
                    </Grid>
                </Grid>
            )
        },
        {
            param: 'apoiadores',
            body: (
                <Grid container direction="column">
                    <GridTitle title="Nossos Apoiadores" />
                    <br />
                    <Grid item>
                        <Typography variant="body1">
                            Agradecemos aos apoiadores que tornaram este evento possível.
                        </Typography>
                        <div style={{ margin: '12px', color: 'black' }}>
                            <div className="silver-sponsor">
                                <Typography variant="h5">
                                    Prata
                                </Typography>
                                <div style={{ justifyContent: 'space-between', marginBottom: '10px' }}>
                                    <a href="https://viveiroflorestalduffatto.com.br/" target="_blank" rel="noopener noreferrer">
                                        <img src={image10} width={150} className="sponsor-image" alt="duffatto" />
                                    </a>
                                </div>
                            </div>

                            <div className="bronze-sponsor">
                                <Typography variant="h5">
                                    Bronze
                                </Typography>
                                <div style={{ justifyContent: 'space-between', marginBottom: '10px' }}>
                                    <a href="https://www.menuai.agr.br/" target="_blank" rel="noopener noreferrer">
                                        <img src={image7} width={150} className="sponsor-image" alt="MENUAI" />
                                    </a>
                                    <a href="https://br.linkedin.com/company/drs-consultoria-e-tecnologia-florestal" target="_blank" rel="noopener noreferrer">
                                        <img src={image8} width={150} className="sponsor-image" alt="DRS" />
                                    </a>
                                    <a href="https://formulanimal.com.br/" target="_blank" rel="noopener noreferrer">
                                        <img src={image9} width={150} className="sponsor-image" alt="FORMULA ANIMAL" />
                                    </a>
                                    <a href="https://www.gateados.com.br/" target="_blank" rel="noopener noreferrer">
                                        <img src={image5} width={150} className="sponsor-image" alt="FLORESTAL GATEADOS" />
                                    </a>
                                    <a href="https://www.facebook.com/TriMaq.ntc/?locale=pt_BR" target="_blank" rel="noopener noreferrer">
                                        <img src={image11} width={150} className="sponsor-image" alt="TRIMAQ" />
                                    </a>
                                </div>
                            </div>

                            <div className="support-sponsor">
                                <Typography variant="h5">
                                    Apoio
                                </Typography>
                                <div style={{ justifyContent: 'space-between', marginBottom: '10px' }}>
                                    <a href="https://ufsc.br" target="_blank" rel="noopener noreferrer">
                                        <img src={image1} width={150} className="sponsor-image" alt="UFSC" />
                                    </a>
                                    <a href="https://www.gov.br/capes/pt-br" target="_blank" rel="noopener noreferrer">
                                        <img src={image6} width={150} className="sponsor-image" alt="CAPES" />
                                    </a>
                                    <a href="https://www.gov.br/cnpq/pt-br" target="_blank" rel="noopener noreferrer">
                                        <img src={image2} width={150} className="sponsor-image" alt="CNPQ" />
                                    </a>
                                    <a href="https://linktr.ee/contatomartinimafra" target="_blank" rel="noopener noreferrer">
                                        <img src={image3} width={150} className="sponsor-image" alt="MARTINI MAFRA" />
                                    </a>
                                    <a href="https://unfoldsoftwaredev.netlify.app/" target="_blank" rel="noopener noreferrer">
                                        <img src={image4} width={150} className="sponsor-image" alt="UNFOLD SOFTWARE DEVELOPMENT" />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </Grid>
                </Grid>
            )
        }
    ];

    const renderText = () => {
        const content = contentList.find(el => el.param === selectedList);
        if (content) {
            return content.body;
        } else {
            return <Grid container direction="column">
                <GridTitle title="Em Breve" />
                <br />
                <Grid item>
                    <div className={classes.logo}>
                        <Bannerette />
                    </div>
                </Grid>
                <Grid item>
                    <Typography variant="body1">
                        Aguarde para mais informações
                    </Typography>
                </Grid>
            </Grid>
        }
    };

    return (
        <Paper className={classes.paper}>
            <div className={classes.itemContainer}>
                <div className={classes.avatarContainer}>
                    <List
                        component="nav"
                        aria-labelledby="duvidas"
                        subheader={
                            <ListSubheader component="div" id="duvidas">
                                Instruções
                            </ListSubheader>
                        }
                        className={classes.root}
                    >
                        {normalListItem.map((el, i) => (
                            <ListItem key={el.link} button selected={selectedList === el.link} onClick={() => handleNormalListItem(el.link)}>
                                <ListItemIcon>
                                    {el.icon}
                                </ListItemIcon>
                                <ListItemText primary={el.title} />
                            </ListItem>
                        ))}
                    </List>
                </div>
                {renderText()}
            </div>
        </Paper>
    );
}
